export default __webpack_public_path__ + "dist/media/Approve.d8759e05.svg";